import sharedConstants from "@lib/shared_constants";

export const messagePrioritizationPaidScheduledActiveOptInLimit =
  sharedConstants.MESSAGE_PRIORITIZATION.PAID_LIMITS.SCHEDULED;

export const messagePrioritizationPaidTriggeredActiveOptInLimit =
  sharedConstants.MESSAGE_PRIORITIZATION.PAID_LIMITS.TRIGGERED;

export const messagePrioritizationPaidCategoriesLimit =
  sharedConstants.MESSAGE_PRIORITIZATION.PAID_LIMITS.CATEGORIES;

export const messagePrioritizationPaidRulesLimit = sharedConstants.MESSAGE_PRIORITIZATION.PAID_LIMITS.RULES;

export const messagePrioritizationPaidRetryWindowDays =
  sharedConstants.MESSAGE_PRIORITIZATION.PAID_LIMITS.RETRY_WINDOW_DAYS;
